import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiArrowLeft, FiDownload } from "react-icons/fi";

import { useEDADashboard } from "./useEDADashboard";
import { formatDashboardTitle } from "./utils";
import { EDAFilters } from "./components/EDAFilters";
import { EDAKpiCards } from "./components/EDAKpiCards";
import { EDASummaryTables } from "./components/EDASummaryTables";
import { EDACharts } from "./components/EDACharts";
import { EDAMainTable } from "./components/EDAMainTable";

const EDAInventorySopDahboardDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { dashboard, selectedProcess } = location.state || {};

  const {
    filters,
    lists,
    dashboardData,
    loading,
    error,
    handleReset
  } = useEDADashboard(location.state);

  if (!location.state) {
    return (
      <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-700">
        Open this page from the dashboard list so the selected dashboard context is available.
      </div>
    );
  }

  const title = formatDashboardTitle(dashboard?.eda_name);

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between mb-2">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">{title}</h1>
          <p className="mt-1 text-sm text-slate-500">
            Process: {formatDashboardTitle(selectedProcess)} | Status:{" "}
            {dashboard?.edaStatus || "Available"}
          </p>
        </div>
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 shadow-sm transition hover:border-slate-300"
        >
          <FiArrowLeft className="h-4 w-4" />
          Back
        </button>
      </div>

      <EDAFilters
        filters={filters}
        lists={lists}
        handleReset={handleReset}
        loading={loading}
      />

      {error && (
        <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">
          {error}
        </div>
      )}

      <EDAKpiCards cards={dashboardData.cards} loading={loading} />

      <div className="mb-5">
        <EDASummaryTables
          summaryTable1={dashboardData.summaryTable1}
          summaryTable2={dashboardData.summaryTable2}
          summaryTable3={dashboardData.summaryTable3}
        />
      </div>

      <EDACharts chart1Data={dashboardData.chart1} chart2Data={dashboardData.chart2} />

      <EDAMainTable mainTable={dashboardData.mainTable} />

      {/* Export Buttons */}
      {dashboard?.Main_EDA_Files && dashboard.Main_EDA_Files.length > 0 && (
        <div className="flex justify-end gap-3 pt-2 pb-5">
          {dashboard.Main_EDA_Files.map((file, idx) => {
            const link = file.xlsLink || file.csvLink;
            if (!link) return null;
            return (
              <a
                key={idx}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-lg bg-[#0060D0] px-4 py-2 text-sm font-semibold !text-white shadow-sm transition hover:bg-[#0050b0]"
              >
                <FiDownload className="h-4 w-4 shrink-0" />
                Download Consolidated Report
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default EDAInventorySopDahboardDetail;
